/**
 * Bundled per-tenant brand defaults (served from apps/app/public).
 * Splash / fallback logos never load from the API — only these static paths.
 */
export type TenantBrandDefaults = {
  /** Primary mark path under the app public root (e.g. /brand/…). */
  logoUrl: string;
  /** Optional inverted mark for dark chrome. */
  logoWhiteUrl?: string;
  wordmark: string;
};

/** Fallback when slug is unknown. */
export const VIPSO_TENANT_BRAND: TenantBrandDefaults = {
  logoUrl: '/brand/logo-sm.svg',
  logoWhiteUrl: '/brand/logo-white.svg',
  wordmark: 'VIPSo',
};

/**
 * Tenant slug → bundled brand assets.
 * Keys match `resolveTenantSlug()` (env suffixes already stripped).
 */
export const TENANT_BRAND_DEFAULTS: Record<string, TenantBrandDefaults> = {
  vipso: VIPSO_TENANT_BRAND,
  omtrading: {
    logoUrl: '/brand/tenants/omtrading.png',
    wordmark: 'Om Trading',
  },
};

export function resolveTenantBrandDefaults(
  slug?: string | null,
): TenantBrandDefaults {
  const key = String(slug ?? '')
    .trim()
    .toLowerCase();
  if (key && TENANT_BRAND_DEFAULTS[key]) {
    return TENANT_BRAND_DEFAULTS[key]!;
  }
  return VIPSO_TENANT_BRAND;
}

export function resolveTenantDefaultLogoUrl(slug?: string | null): string {
  return resolveTenantBrandDefaults(slug).logoUrl;
}
